import { render } from "./chart.vue?vue&type=template&id=704b5af6"
import script from "./chart.vue?vue&type=script&lang=js"
export * from "./chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__